<template>
  <div id="tabBox">

    <div id="tabs">
      <label v-for="(title, key) of Tabs" :key="key"
        class="mb-0 mr-1" :class="{ selected: selected === key }"
        @click="selected = key">{{ title }}</label>
    </div>

    <div id="contents">
      <ChargeGroups v-show="selected === 'groups'" :tutor="tutor" />
      <Contracts v-show="selected === 'contracts'" :tutor="tutor" />
    </div>

  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Tutor } from '@/store/tutors/types'
import ChargeGroups from '@/components/parts/tutor/profile/ChargeGroups.vue'
import Contracts from '@/components/parts/tutor/profile/Contracts.vue'

const Tabs = {
  groups: 'Charge Groups',
  contracts: 'Contracts',
}
type tabKey = keyof typeof Tabs

@Component({
  components: {
    ChargeGroups,
    Contracts,
  },
})
export default class TutorProfileHistories extends Vue {
  @Prop({ required: true }) tutor!: Tutor

  private Tabs = Tabs

  private selected: tabKey = 'groups'
}
</script>

<style lang="scss" scpoed>
#tabBox {
  margin-top: 50px;

  #tabs {
    overflow: hidden;
    display: flex;
    margin-left:40px;

    input {
      display: none;
    }

    label {
      display: inline-block;
      line-height: 40px;
      width: 150px;
      text-align: center;
      cursor: pointer;
      background: #bbc0bf;
      color: #000;
      transition: 0.3s ease-in-out;
      border-radius: 10px 10px 0 0;
    }

    label.selected,
    label:hover {
      background: #1cc8a0;
      color: #fff;
    }
  }

  #contents {
    padding: 40px;
    min-height: 400px;
    max-height: 800px;
    margin-bottom:20px;
    background: #fff;
    border-radius: 20px ;

    tbody td {
      font-size: 1em !important;
    }
  }
}
</style>
